import { jsx as _jsx } from "react/jsx-runtime";
/********************************************************************************
 * Copyright (c) 2020 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { useContext, useRef } from 'react';
import { isError } from '../../extension-registry-types';
import { NamespaceDetailConfigContext } from './namespace-detail-config';
import { MainContext } from '../../context';
import { AddUserDialog } from '../add-user-dialog';
export const AddMemberDialog = props => {
    const config = useContext(NamespaceDetailConfigContext);
    const { service, handleError } = useContext(MainContext);
    const abortController = useRef(new AbortController());
    const existingUsers = props.members.map(m => m.user);
    const handleAddUser = async (user) => {
        try {
            if (!props.namespace) {
                return;
            }
            props.setLoadingState(true);
            const endpoint = props.namespace.roleUrl;
            const result = await service.setNamespaceMember(abortController.current, endpoint, user, config.defaultMemberRole ?? 'contributor');
            if (isError(result)) {
                throw result;
            }
            props.setLoadingState(false);
            props.onClose();
        }
        catch (err) {
            props.setLoadingState(false);
            handleError(err);
        }
    };
    return (_jsx(AddUserDialog, { open: props.open, title: 'Add Member', description: 'Enter the Login Name of the User you want to add.', existingUsers: existingUsers, filterUsers: config.filterUsers, onClose: props.onClose, onAddUser: handleAddUser }));
};
//# sourceMappingURL=add-namespace-member-dialog.js.map